import React from 'react';
import { Users, Stethoscope, Leaf, ShieldCheck } from 'lucide-react';
const trustItems = [{
  icon: <Users size={20} data-id="element-107" />,
  text: '80.000+ zufriedene Kunden'
}, {
  icon: <Stethoscope size={20} data-id="element-108" />,
  text: 'Von Tierärzten empfohlen'
}, {
  icon: <Leaf size={20} data-id="element-109" />,
  text: '100% pflanzlich & natürlich'
}, {
  icon: <ShieldCheck size={20} data-id="element-110" />,
  text: 'Geld-zurück-Garantie'
}];
export function TrustBar() {
  return <div className="w-full bg-forest-green text-white py-6 px-4" data-id="element-111">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center" data-id="element-112">
        {trustItems.map((item, index) => <div key={index} className="flex items-center gap-2 font-medium text-sm md:text-base" data-id="element-113">
            <span className="text-cream" data-id="element-114">{item.icon}</span>
            <span data-id="element-115">{item.text}</span>
          </div>)}
      </div>
    </div>;
}